import * as React from 'react';

import styles from './index.css';
import { NBSP } from '../../constants';
import { trackOpenRailwayLink } from '../../tracking';
import { IStationInfoSchema } from '../../types';
import { getDistanceRailway } from '../../utils/helpers';
import { RailwayIcon } from '../common/icons';

export const StationCommuteRow = (stationItem: IStationInfoSchema) => {
  if (!stationItem) {
    return null;
  }

  const { stationName, directionName, seo } = stationItem;

  if (!stationName || !directionName) {
    return null;
  }
  const name = `${stationName} (напр. ${directionName})`;

  const link = seo ? seo.url : '';
  const distance = getDistanceRailway(stationItem);

  return (
    <div className={styles['commute']}>
      <span className={styles['commute-icon']}>
        <RailwayIcon />
      </span>
      <a className={styles['address-link']} href={link} onClick={trackOpenRailwayLink} target="_blank">
        <span>{name}</span>
      </a>
      {distance && (
        <>
          ,{NBSP}
          <span className={styles['commute-distance']}>{distance}</span>
        </>
      )}
    </div>
  );
};
